import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ko from "./ko.json";
import en from "./en.json";
import ja from "./ja.json";

// 우선순위: localStorage 저장값 > 유저 프로필 locale > 디바이스 언어 > 기본 한국어
const getSavedLang = (): string => {
    const saved = localStorage.getItem('dokocrew_language');
    if (saved) return saved;
    try {
        const userInfo = sessionStorage.getItem('dokocrew_user_info');
        if (userInfo) {
            const parsed = JSON.parse(userInfo);
            if (parsed.locale) return parsed.locale;
        }
    } catch {}
    return window.__DEVICE__?.language || "ko";
};

export const initI18n = () => {
    const lng = getSavedLang();
    i18n.use(initReactI18next).init({
        resources: {
            ko: { translation: ko },
            en: { translation: en },
            ja: { translation: ja },
        },
        lng,
        fallbackLng: "ko",
        interpolation: {
            escapeValue: false,
        },
    });

    // html lang 을 앱 언어와 맞춘다 — 브라우저가 언어를 잘못 알고(영어) 번역을 띄우거나
    // 대체 글씨체를 다른 언어 기준으로 고르지 않게 (wiz-sso-front 와 같은 처리)
    document.documentElement.lang = i18n.language || lng;
    i18n.on("languageChanged", (lng) => {
        document.documentElement.lang = lng;
    });
};

/** 언어 변경 + localStorage 저장 + 새로고침 */
export const changeLanguage = (lang: string) => {
    localStorage.setItem('dokocrew_language', lang);
    i18n.changeLanguage(lang);
    window.location.reload();
};

export default initI18n;
